"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioCardGroupPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const grid_props_js_1 = require("./grid.props.js");
const sizes = ['1', '2', '3'];
const variants = ['surface', 'classic'];
const radioCardGroupPropDefs = {
    asChild: index_js_1.asChildProp,
    size: { type: 'enum', className: 'rt-r-size', values: sizes, default: '2', responsive: true },
    variant: { type: 'enum', className: 'rt-variant', values: variants, default: 'surface' },
    color: index_js_1.colorProp,
    highContrast: index_js_1.highContrastProp,
    columns: { ...grid_props_js_1.gridPropDefs.columns, default: 'repeat(auto-fit, minmax(160px, 1fr))' },
    gap: { ...grid_props_js_1.gridPropDefs.gap, default: '4' },
};
exports.radioCardGroupPropDefs = radioCardGroupPropDefs;
//# sourceMappingURL=radio-card-group.props.js.map